/**
 * Проекты для окошек Latest works и страницы All projects.
 */

export const PROJECTS_COPY = {
    title: "All projects",
};

export const PROJECTS = [
    {
        id: "your-site",
        title: "There is might be your site!",
        image: "",
        placeholder: true,
        action: "order",
        button: "Order a site",
    },
    {
        id: "msp",
        title: "Media Service Projector",
        image: "/msprojector.png",
        path: "/program",
        action: "view",
        button: "Watch more",
    },
    {
        id: "making-sense",
        title: "Making Sense",
        image: "/pc1.png",
        path: "/code-redactor",
        action: "view",
        button: "Watch more",
    },
    {
        id: "admin-panel",
        title: "Admin Panel",
        image: "/admin-pc.png",
        path: "/admin-panel",
        action: "view",
        button: "Watch more",
    },
];

// config/projects.js
